import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import { createPersistStorage } from '@vipso/shared';
import authReducer from './authSlice';
import { baseApi } from './baseApi';
import { scopeApi } from '../api/scopeApi';

const authPersistConfig = {
  key: 'vipso-auth',
  storage: createPersistStorage(),
  // Do NOT persist `bootstrapped` — every web refresh / native kill-reopen
  // re-runs AppBootstrap (fresh scope + session).
  // Do NOT persist theme/config/tenant* — login branding must come from a
  // fresh GET /api/public/scope on every load, not stale localStorage.
  whitelist: [
    'accessToken',
    'refreshToken',
    'user',
    'org',
    'membershipId',
    'featureKeys',
    'orgFeatures',
    'orgs',
    'socketRooms',
    'pendingTaskCount',
    'operationsLocked',
    'lastOrgId',
  ],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  [baseApi.reducerPath]: baseApi.reducer,
  [scopeApi.reducerPath]: scopeApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(baseApi.middleware, scopeApi.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
